var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { assetClassMapWithCode, } from "@domains/dto/Reports/HoldingReport/HoldingMainDTO";
import { roundUpToTwoDecimalPlaces } from "@domains/utils/numberMethods";
export function holdingMapper(data) {
    if (data) {
        var initial = new Array();
        var holdingDetail = data.holdingDetail, holdingSummary = data.holdingSummary, isOmneOnly_1 = data.isOmneOnly;
        var mappedHoldingDetails = holdingDetail.reduce(function (acc, record, idx) {
            acc.push(__assign(__assign({}, record), { displayName: record.quote.displayName, changePercentage: roundUpToTwoDecimalPlaces(Number(record.quote.changePercentage)), quote: isOmneOnly_1
                    ? __assign(__assign({}, record.quote), { assetCode: assetClassMapWithCode[record.edelweissAssetClass] }) : record.quote, scripIdentifier: record.scripIdentifier, rowNumber: idx, lastTradedPrice: record.quote.lastTradedPrice }));
            return acc;
        }, initial);
        return {
            HoldingDetails: mappedHoldingDetails,
            HoldingSummary: holdingSummary,
            isOmneOnly: isOmneOnly_1,
        };
    }
    else {
        return null;
    }
}
